var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCategorySmileys = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0c5.523 0 10 4.477 10 10s-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0Zm.013 1.25a8.75 8.75 0 1 0 0 17.5 8.75 8.75 0 0 0 0-17.5Zm3.425 5c.518 0 .937.559.937 1.25s-.42 1.25-.938 1.25-.937-.559-.937-1.25.42-1.25.938-1.25Zm-6.253 0c.517 0 .936.559.936 1.25s-.416 1.25-.936 1.25c-.519 0-.935-.559-.935-1.25s.419-1.25.935-1.25Zm2.823 5.844c3.45 0 6.25-1.476 6.25-.687a6.25 6.25 0 0 1-12.5 0c0-.787 2.798.687 6.25.687ZM15 12.62c0-.55-1.963.625-5 .625s-5-1.175-5-.625c0 2.392 3.636 2.5 5 2.5h.154c1.599-.01 4.846-.186 4.846-2.5Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCategorySmileys);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/category-smileys.5764c3064a313e461a9094d62036d58e.svg";